module.exports = __webpack_public_path__ + "static/media/016.c86dd637.jpg";